import React from "react";
import { connect } from "react-redux";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { theme } from "styles/theme";
import Button from "components/form/button";
import { formatMessage } from "lib/globalize-util";
import { setApplied as setAppliedDimensionParamsAction } from "actions/tool-panel/applied/actions";
import { SetApplied as SetApplyDimensionParams } from "actions/tool-panel/applied/types";
import { DimensionsPanelReduxState } from "reducers/dimensions-panel/dimensions-panel";
import { metricsTimerStart } from "helpers/metrics";
import { DATATEST } from "constants/integration";
import { trackDimensionsPanelAnalytics } from "./utils";

interface IOwnProps {
    isApplyDisabled: boolean;
    isRollupMode: boolean;
    errorMessage?: string;
    warningMessage: string | null;
}

interface IStateProps {
    draftState: DimensionsPanelReduxState;
}
interface IDispatchProps {
    setApplied: SetApplyDimensionParams;
}

export const DimensionsToolPanelFooterComponent: React.FunctionComponent<IOwnProps & IStateProps & IDispatchProps> = ({
    setApplied,
    draftState,
    isApplyDisabled,
    errorMessage,
    warningMessage,
    isRollupMode,
}) => (
    <div className="dimensionsFooterContainer">
        <div className="dimensionsFooterButtonContainer">
            <Button
                data-test={DATATEST.TOOL_PANEL.DOORS.APPLY_BTN}
                disabled={isApplyDisabled}
                className="dimensionsButton"
                label={formatMessage("Apply")}
                primary={true}
                onClick={() => {
                    metricsTimerStart();
                    setApplied(draftState);
                    trackDimensionsPanelAnalytics(draftState, isRollupMode);
                }}
            />
        </div>
        {!!errorMessage && (
            <div className="dimensionsErrorContainer">
                <ErrorOutlineIcon style={{ color: `${theme.palette.errorAlertTextColor}`, marginRight: "1rem" }} />
                <span className="errorText">{errorMessage}</span>
            </div>
        )}
        {!!warningMessage && (
            <div className="dimensionsWarningContainer">
                <ErrorOutlineIcon style={{ color: `${theme.palette.errorAlertTextColor}`, marginRight: "1rem" }} />
                <span className="warningText">{warningMessage}</span>
            </div>
        )}
    </div>
);

export const DimensionsToolPanelFooter = connect<IStateProps, IDispatchProps, IOwnProps>(
    (state) => ({
        draftState: state.dimensionsPanel.draft,
    }),
    {
        setApplied: setAppliedDimensionParamsAction,
    }
)(DimensionsToolPanelFooterComponent);
